import { useSelector } from "react-redux";
import "antd/dist/antd.min.css";
import "./App.css";
import PublicPages from "./pages/Public";
import Roles from "./pages/Roles";

function App() {
  const isUserLoggedin = useSelector((state) => state.token.tokenData);
  return (
    <div className="app flex">
      {isUserLoggedin ? (
        <>
          <Roles />
        </>
      ) : (
        <PublicPages />
      )}
    </div>
  );
}

export default App;
